import { c as _c } from "react/compiler-runtime";
import { getOrgAgentsToolsOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
import { useOptionalBuilder } from '../../store/provider';
import { buildReferenceIndex, EMPTY_REFERENCE_INDEX, type ReferenceIndex } from './reference-index';

/**
 * Live index of everything prompts can reference, for chip-highlighting prose previews.
 * Outside the builder provider (e.g. isolated stories) it's empty, so nothing chips.
 */
const useReferenceIndex = () => {
  const $ = _c(6);
  const builder = useOptionalBuilder();
  const bundle = builder?.state.bundle;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getOrgAgentsToolsOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = !!bundle;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      ...t0,
      enabled: t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data
  } = useQuery(t2);
  let t3;
  if ($[3] !== bundle || $[4] !== data?.tools) {
    t3 = bundle ? buildReferenceIndex({
      bundle,
      toolCatalog: data?.tools ?? []
    }) : EMPTY_REFERENCE_INDEX;
    $[3] = bundle;
    $[4] = data?.tools;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default useReferenceIndex;